const recovery = () => import('@/views/main/receipt/recovery/recovery.vue')
export default {
  path: '/main/receipt/recovery',
  name: 'recovery',
  component: recovery,
  children: []
}
